import { render } from "./AlertControl.vue?vue&type=template&id=06f82f56&scoped=true"
import script from "./AlertControl.vue?vue&type=script&lang=js"
export * from "./AlertControl.vue?vue&type=script&lang=js"

import "./AlertControl.vue?vue&type=style&index=0&id=06f82f56&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f82f56"]])

export default __exports__